import type { GetStaticPropsContext } from 'next';

import { PageCategory } from '~/features/analytics/constants';
import {
  StaticPartnershipsSectionProps,
  transformStaticPartnershipsSectionProps,
} from '~/features/experiments/ab_plp_redesign_2025/components/partnerships-section';
import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { PlansPage } from '~/features/plans/components/plans-page';
import { getAllThirdPartyReviews } from '~/features/third-party-reviews/controller';
import { ThirdPartyReviewContentList } from '~/features/third-party-reviews/model';

export default function Plans({
  partnershipsSectionProps,
  page,
  thirdPartyReviews,
}: {
  page: Page;
  partnershipsSectionProps: StaticPartnershipsSectionProps;
  thirdPartyReviews: ThirdPartyReviewContentList;
}) {
  return (
    <>
      <PageHead page={page} pageCategory={PageCategory.Plans} />
      <PageLayout withoutVerticalPadding>
        <PlansPage partnershipsSectionProps={partnershipsSectionProps} thirdPartyReviews={thirdPartyReviews} />
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  // Stop additional locale pages except the default locale from being built
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const [page, partnershipsSectionProps, thirdPartyReviews] = await Promise.all([
    getPage('/plans'),
    transformStaticPartnershipsSectionProps(),
    getAllThirdPartyReviews(),
  ]);

  return {
    props: {
      page,
      partnershipsSectionProps,
      thirdPartyReviews,
    },
  };
}
